import Quizz from './components/Quizz/Quizz';
export { Quizz };
export { quizzReducers } from './components/Quizz/quizzReducers';
export { setUserPreviousAnswsers } from './components/Quizz/quizzActions';

export { firebase } from './utils/firebase/firebase';


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-quiz/es/index.js
// module id = 40
// module chunks = 0